export default {
      id: "reports_alarms-usage",
      viewBox: "0 0 53 52",
      url: __webpack_public_path__ + "img/icons.svg#reports_alarms",
      toString: function () {
        return this.url;
      }
    }